export default class Faq {

    constructor() {
        this.addEvents();
        this.checkHash();
    }

    addEvents() {

        $('.faq__bt--question').on('click', function() {
            $(this).parents('.faq__bt--item').find('.faq__bt--content').slideUp();
            $(this).toggleClass('open');
            if($(this).next().is(':hidden')) {
                $(this).next().slideDown();
            } else {
                $(this).next().slideUp();
            }
        });

        $('.faq__bt--more').on('click', function() {
            if($(this).text() == 'Expand all'){
                $(this).html('Hide all');
                $(this).parents('.faq__bt').find('.faq__bt--item .faq__bt--content').slideDown();
                $(this).parents('.faq__bt').find('.faq__bt--item .faq__bt--question').addClass('open').slideDown();
            }else{
                $(this).html('Expand all');
                $(this).parents('.faq__bt').find('.faq__bt--item .faq__bt--content').slideUp();
                $(this).parents('.faq__bt').find('.faq__bt--item .faq__bt--question').removeClass('open');
            }
        });


    }

    checkHash() {
        if(window.location.hash == '#ownership' && $('div').hasClass('second-faq')){
            $( document ).ready(function() {
                setTimeout(() => {
                    let top = $('.second-faq').offset().top;
                    $('body,html').animate({scrollTop: top}, 1000);
                    $('.second-faq .elementor-toggle-item:last-child .elementor-tab-title a').click();
                }, 500);
            });
        }
    }

}


